export var displayableError = function displayableError(meta) {
  // If there is no value set yet (even a null), don't show an error
  if (!("value" in meta)) {
    return "";
  }
  // If there is both an initial value and a value and they match, don't show an error
  if ("initialValue" in meta) {
    if (meta.value === meta.initialValue) {
      return "";
    }
  }
  return meta.error;
};